<div class="body-container">
    <ng-content></ng-content>
</div>